import React from 'react'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import { AmenityItem } from './amenity-item'

import { Amenity } from 'generated/mos/org/getty/visitorinfo'

import { dndReorder } from 'helpers/drag-and-drop'

type Props = {
  readonly orderedAmenities: ReadonlyArray<Amenity.Entity>;
  readonly setOrderedAmenities: (amenities: ReadonlyArray<Amenity.Entity>) => void;
  readonly deleteHandler: (amenity: Amenity.Entity) => void;
  readonly updateHandler: (amenity: Amenity.Entity) => void;
}

export const ReorderableAmenities = ({ orderedAmenities, setOrderedAmenities, deleteHandler, updateHandler }: Props) => {
  return (
    <DragDropContext onDragEnd={dropResult => setOrderedAmenities(dndReorder(dropResult, orderedAmenities))}>
      <Droppable droppableId="amenities-list">
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {orderedAmenities.map((amenity, index) => {
              const id = amenity.ref ? amenity.ref.id : ''
              return (
                <Draggable draggableId={id} key={id} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <AmenityItem
                        isDragging={snapshot.isDragging}
                        draggableIndex={index}
                        amenity={amenity}
                        deleteHandler={deleteHandler}
                        updateHandler={updateHandler}
                      />
                    </div>
                  )}
                </Draggable>
              )
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  )
}
